import React from 'react';
import { Button, makeStyles, Typography, Box } from "@material-ui/core";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

export default function Contato() {
  const classes = useStyles();
  const waLink = "https://wa.me/5535999500713"; // sem mensagem

  return (
    <div className={classes.root}>
      <div className={classes.desktop}>
        <Box className={classes.highlight}>
          <Typography className={classes.titulo} align="center">
            Entre em Contato
          </Typography>
          <Typography className={classes.subtituloTexto}>
            Divulgue sua marca nos registros mais vistos de Campo e região!
          </Typography>
          <Typography className={classes.texto}>
            O Arquivo Roberto Murilo conecta história, memória e o dia a dia da nossa cidade através de fotos e vídeos publicados no portal, Instagram e Facebook.
          </Typography>
          <Typography className={classes.texto}>
            Fale com a gente e descubra como podemos caminhar juntos nessa parceria.
          </Typography>

          <div className={classes.ctaRow}>
            <Typography className={classes.email}>contatorobertomurilo@gmail.com</Typography>
            <Button
              className={classes.ctaWhats}
              color="primary"
              variant="contained"
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<WhatsAppIcon />}
            >
              Falar no WhatsApp
            </Button>
          </div>
        </Box>
      </div>

      <div className={classes.mobile}>
        <div className={classes.limitM}>
          <Box className={classes.highlightM}>
            <Typography className={classes.tituloM} align="center">
              Entre em Contato
            </Typography>
            <Typography className={classes.subtituloTextoM}>
              Divulgue sua marca nos registros mais vistos de Campo e região!
            </Typography>
            <Typography className={classes.textoM}>
              O Arquivo Roberto Murilo conecta história, memória e o dia a dia da nossa cidade através de fotos e vídeos publicados no portal, Instagram e Facebook.
            </Typography>
            <Typography className={classes.textoM}>
              Fale com a gente e descubra como podemos caminhar juntos nessa parceria.
            </Typography>

            <div className={classes.ctaRowM}>
              <Typography className={classes.emailM}>contatorobertomurilo@gmail.com</Typography>
              <Button className={classes.ctaWhatsM} color="primary" variant="contained" href={waLink} target="_blank" rel="noopener noreferrer" startIcon={<WhatsAppIcon />}>
                WhatsApp
              </Button>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  desktop: {
    marginTop: "32px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobile: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    paddingBottom: "40px",
    paddingLeft: "5px",
    paddingRight: "5px",
    gap: "32px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  highlight: {
    width: '100%',
    maxWidth: 1126,
    margin: '0 auto',
    borderRadius: 16,
    padding: '32px 28px',
    background: 'linear-gradient(180deg, rgba(0,97,178,0.08) 0%, rgba(0,136,223,0.04) 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  highlightM: {
    width: '100%',
    borderRadius: 16,
    padding: '20px 16px',
    background: 'linear-gradient(180deg, rgba(0,97,178,0.10) 0%, rgba(0,136,223,0.05) 100%)',
  },
  limitM: {
    width: "100%",
    maxWidth: "540px",
  },
  titulo: {
    alignSelf: "flex-Start",
    font: "Rubik",
    fontSize: "48px",
    color: theme.colors.gray1,
  },
  subtituloTexto: {
    alignSelf: 'flex-start',
    marginTop: 16,
    font: 'Karla',
    fontSize: 24,
    fontWeight: 600,
    color: theme.colors.gray2,
    maxWidth: 900,
  },
  texto: {
    alignSelf: 'flex-start',
    marginTop: 16,
    font: 'Karla',
    fontSize: '20px',
    color: theme.colors.gray2,
    maxWidth: '900px',
  },
  tituloM: {
    marginTop: "16px",
    font: "Rubik",
    fontSize: "24px",
    color: theme.colors.gray1,
    alignSelf: "flex-start",
  },
  subtituloTextoM: {
    marginTop: 8,
    font: 'Karla',
    fontSize: 18,
    fontWeight: 600,
    color: theme.colors.gray2,
    alignSelf: 'flex-start',
  },
  textoM: {
    marginTop: 8,
    font: 'Karla',
    fontSize: '16px',
    color: theme.colors.gray2,
    alignSelf: 'flex-start',
  },
  botaosub: {
    marginTop: "-36px",
    width: "145px",
    height: "51px",
    backgroundColor: theme.colors.darkBlue,
    color: theme.colors.white,
    font: "Karla",
    fontSize: "25px",
  },
  botaosubM: {
    marginTop: "-16px",
    width: "129px",
    height: "46px",
    backgroundColor: theme.colors.darkBlue,
    color: theme.colors.white,
    font: "Karla",
    fontSize: "18px",
  },
  editor: {
    width: "100%",
  },
  contentD: {
    width: "100%",
    alignItems: "center",
    paddingBottom: "40px",
    flexDirection: "column",
    display: "flex",
  },
  ctaRow: {
    marginTop: 28,
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  ctaRowM: {
    marginTop: 16,
    display: 'flex',
    gap: 12,
    flexDirection: 'column',
    alignItems: 'center',
  },
  ctaEmail: {
    textTransform: 'none',
    padding: '12px 20px',
    fontWeight: 600,
    borderRadius: 999,
    '&:hover': {
      backgroundColor: 'rgba(0,97,178,0.10)'
    }
  },
  ctaWhats: {
    textTransform: 'none',
    padding: '12px 20px',
    fontWeight: 700,
    borderRadius: 999,
    boxShadow: '0 6px 16px rgba(0,97,178,0.22)',
    '&:hover': {
      backgroundColor: theme.colors.lightBlue
    }
  },
  ctaEmailM: {
    textTransform: 'none',
    padding: '12px 20px',
    fontWeight: 600,
    borderRadius: 999,
    width: '100%'
  },
  ctaWhatsM: {
    textTransform: 'none',
    padding: '12px 20px',
    fontWeight: 700,
    borderRadius: 999,
    width: '100%'
  },
  email: {
    font: 'Karla',
    fontSize: 18,
    color: theme.colors.gray1,
    textAlign: 'center',
    marginBottom: 8,
  },
  emailM: {
    font: 'Karla',
    fontSize: 16,
    color: theme.colors.gray1,
    textAlign: 'center',
  },
  obrigadoD: {
    width: "100%",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    paddingBottom: "50px",
  },
  obrigadoM: {
    width: "100%",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    paddingBottom: "27px",
  },
  obrigadoDtxt: {
    font: "Rubik",
    fontSize: "54px",
    color: "#5D5E60",
  },
  obrigadoDbutton: {
    marginTop: "44px",
    font: "Karla",
    fontSize: "30px",
    color: theme.colors.white,
    height: "70px",
    width: "508px",
    backgroundColor: theme.colors.darkBlue,
  },
  obrigadoMtxt: {
    font: "Rubik",
    fontSize: "24px",
    color: "#5D5E60",
  },
  obrigadoMbutton: {
    marginTop: "34px",
    font: "Karla",
    fontSize: "16px",
    color: theme.colors.white,
    height: "46px",
    width: "254px",
    backgroundColor: theme.colors.darkBlue,
  },
}));
